import { useEffect } from "react";
import PublicMenuPage from "@/components/menu/public/page/PublicMenuPage";

const PublicMenu = () => {
  // Add a class to the body for specific styling
  useEffect(() => {
    document.body.classList.add("public-menu-page");
    return () => {
      document.body.classList.remove("public-menu-page");
    };
  }, []);

  return <PublicMenuPage />;
};

export default PublicMenu;
